import React from "react";

export default function DownloadFile({state}) {
  console.log(state)
  const downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(state)], {
      type: "text/plain"
    });
    element.href = URL.createObjectURL(file);
    element.download = "myFile.txt";
    document.body.appendChild(element);
    element.click();
  };

  return (
    <div>
      <button onClick={downloadTxtFile} className="btn btn-primary mb-5">Download Data</button>
    </div>
  );
}
